import { FormVals } from "@/components/Form"
import allNM from "@/components/NormalDist/config"

// ATVM, PTVM, SC(LSC), HUS(ULS), SLFF, LEFORT(Colpoclesis)
// type CalColums = [number, number, number, number,number, number]

const ifGreaterThanOne = (formFieldVal: number, curveArea: number) => {
  if (formFieldVal > 1) {
    return curveArea
  }
  return 1
}

// 對應 Excel Sheet2 Calculation Table
// 每個cell有不同的轉換規則

const getCalculation = (formVals: FormVals) => {
  const {
    Q4,
    Q5,
    Q6,
    Q7,
    Q8,
    Q11_a,
    Q11_b,
    Q11_c,
    Q12,
    BMI
  } = formVals

  const [tA, tC, tP] = [0, -16 / 3, 0]

  const Anterior_ATVM = ifGreaterThanOne(+Q11_a, allNM.ANTERIOR_ATVM_NM.getBellCurveArea(+Q11_a - tA))
  const Central_ATVM = ifGreaterThanOne(+Q11_b, allNM.CENTRAL_ATVM_NM.getBellCurveArea(+Q11_b - tC))
  const Posterior_ATVM = ifGreaterThanOne(+Q11_c, allNM.POSTERIOR_ATVM_NM.getBellCurveArea(+Q11_c - tP))

  const Anterior_LSC = ifGreaterThanOne(+Q11_a, allNM.ANTERIOR_LSC_NM.getBellCurveArea(+Q11_a - tA))
  const Central_LSC = ifGreaterThanOne(+Q11_b, allNM.CENTRAL_LSC_NM.getBellCurveArea(+Q11_b - tC))
  const Posterior_LSC = ifGreaterThanOne(+Q11_c, allNM.POSTERIOR_LSC_NM.getBellCurveArea(+Q11_c - tP))

  const Anterior_SLFF = ifGreaterThanOne(+Q11_a, allNM.ANTERIOR_SLFF_NM.getBellCurveArea(+Q11_a - tA))
  const Central_SLFF = ifGreaterThanOne(+Q11_b, allNM.CENTRAL_SLFF_NM.getBellCurveArea(+Q11_b - tC))
  const Posterior_SLFF = ifGreaterThanOne(+Q11_c, allNM.POSTERIOR_SLFF_NM.getBellCurveArea(+Q11_c - tP))

  const Anterior_ULS = ifGreaterThanOne(+Q11_a, allNM.ANTERIOR_ULS_NM.getBellCurveArea(+Q11_a - tA))
  const Central_ULS = ifGreaterThanOne(+Q11_b, allNM.CENTRAL_ULS_NM.getBellCurveArea(+Q11_b - tC))
  const Posterior_ULS = ifGreaterThanOne(+Q11_c, allNM.POSTERIOR_ULS_NM.getBellCurveArea(+Q11_c - tP))

  const Anterior_PTVM = ifGreaterThanOne(+Q11_a, allNM.ANTERIOR_PTVM_NM.getBellCurveArea(+Q11_a - tA))
  const Central_PTVM = ifGreaterThanOne(+Q11_b, allNM.CENTRAL_PTVM_NM.getBellCurveArea(+Q11_b - tC))
  const Posterior_PTVM = ifGreaterThanOne(+Q11_c, allNM.POSTERIOR_PTVM_NM.getBellCurveArea(+Q11_c - tP))

  const Anterior_LEFORT = ifGreaterThanOne(+Q11_a, allNM.ANTERIOR_LEFORT_NM.getBellCurveArea(+Q11_a - tA))
  const Central_LEFORT = ifGreaterThanOne(+Q11_b, allNM.CENTRAL_LEFORT_NM.getBellCurveArea(+Q11_b - tC))
  const Posterior_LEFORT = ifGreaterThanOne(+Q11_c, allNM.POSTERIOR_LEFORT_NM.getBellCurveArea(+Q11_c - tP))


  // const Prior =
  //   [Q7 == "1" ? 0.01 : 0.31289111,
  //   Q7 == "1" ? 0.01 : 0.03128911,
  //     0.14142678,
  //     0.20650814,
  //     0.14392991,
  //   Q5 == "1" || Q6 == "1" ? 0.001 : 0.16395494]
  const Prior = [
    Q7 == "1" ? 0.01 : 1,
    Q7 == "1" ? 0.01 : Math.exp((-0.6029015) - (0.08096803 * Number(Q8)) + (0.12943607 * Number(BMI)) - (0.7407001 * Number(Q11_a)) - (0.03223329 * Number(Q11_b)) + (1.1111208 * Number(Q11_c))),
    Math.exp((13.0981169) - (0.25289741 * Number(Q8)) + (0.03293046 * Number(BMI)) - (0.139 * Number(Q11_a)) + (0.16788148 * Number(Q11_b)) + (0.223397 * Number(Q11_c))),
    Math.exp((12.7901709) - (0.18441006 * Number(Q8)) - (0.06146691 * Number(BMI)) - (1.0139354 * Number(Q11_a)) + (0.12109017 * Number(Q11_b)) - (0.6124810 * Number(Q11_c))),
    Math.exp((3.9111763) - (0.06932555 * Number(Q8)) + (0.03180572 * Number(BMI)) - (0.7089702 * Number(Q11_a)) + (0.25466944 * Number(Q11_b)) - (0.3218465 * Number(Q11_c))),
    (Q5 == '1' || Q6 == '1') ? 0.001 : Math.exp((-21.9338015) + (0.32276837 * Number(Q8)) + (0.01499959 * Number(BMI)) - (0.2851394 * Number(Q11_a)) + (0.02715843 * Number(Q11_b)) + (0.3245197 * Number(Q11_c)))
  ]

  const OperationComplexity =
    [Q12 == "1" ? 1 / 0.98 : 1,
    Q12 == "1" ? 1 / 0.98 : 1,
      1,
    Q12 == "1" ? 1 / 0.9 : 1,
    Q12 == "1" ? 1 / 0.9 : 1,
    Q12 == "1" ? 1 / 0.9 : 1,
    ]

  const AGE_ROW =
    [
      allNM.AGE_ATVM_NM.getBellCurveArea(+Q8 - 1, +Q8 + 1),
      allNM.AGE_PTVM_NM.getBellCurveArea(+Q8 - 1, +Q8 + 1),
      allNM.AGE_LSC_NM.getBellCurveArea(+Q8 - 1, +Q8 + 1),
      allNM.AGE_ULS_NM.getBellCurveArea(+Q8 - 1, +Q8 + 1),
      allNM.AGE_SLFF_NM.getBellCurveArea(+Q8 - 1, +Q8 + 1),
      allNM.AGE_LEFORT_NM.getBellCurveArea(+Q8 - 1, +Q8 + 1),
    ]

  const BMI_ROW =
    [
      allNM.BMI_ATVM_NM.getBellCurveArea(+BMI - 0.1, +BMI + 0.1),
      allNM.BMI_PTVM_NM.getBellCurveArea(+BMI - 0.1, +BMI + 0.1),
      allNM.BMI_LSC_NM.getBellCurveArea(+BMI - 0.1, +BMI + 0.1),
      allNM.BMI_ULS_NM.getBellCurveArea(+BMI - 0.1, +BMI + 0.1),
      allNM.BMI_SLFF_NM.getBellCurveArea(+BMI - 0.1, +BMI + 0.1),
      allNM.BMI_LEFORT_NM.getBellCurveArea(+BMI - 0.1, +BMI + 0.1),
    ]

  const CharacteristicTotal =
    [
      AGE_ROW[0] * BMI_ROW[0],
      AGE_ROW[1] * BMI_ROW[1],
      AGE_ROW[2] * BMI_ROW[2],
      AGE_ROW[3] * BMI_ROW[3],
      AGE_ROW[4] * BMI_ROW[4],
      AGE_ROW[5] * BMI_ROW[5],
    ]

  const EffectivenessTotal =
    [
      Anterior_ATVM * Central_ATVM * Posterior_ATVM,
      Anterior_PTVM * Central_PTVM * Posterior_PTVM,
      Anterior_LSC * Central_LSC * Posterior_LSC,
      Anterior_ULS * Central_ULS * Posterior_ULS,
      Anterior_SLFF * Central_SLFF * Posterior_SLFF,
      Anterior_LEFORT * Central_LEFORT * Posterior_LEFORT,
    ]

  const CharacteristicEffectiveness =
    [
      CharacteristicTotal[0] * EffectivenessTotal[0],
      CharacteristicTotal[1] * EffectivenessTotal[1],
      CharacteristicTotal[2] * EffectivenessTotal[2],
      CharacteristicTotal[3] * EffectivenessTotal[3],
      CharacteristicTotal[4] * EffectivenessTotal[4],
      CharacteristicTotal[5] * EffectivenessTotal[5],
    ]

  const Safety =
    [1 / 0.142, 1 / 0.142, 1 / 0.124, 1 / 0.11, 1 / 0.11, 1 / 0.114]

  const Cost =
    [
      Q4 == "1" ? 1 / 27644 : 1,
      Q4 == "1" ? 1 / 22447 : 1,
      Q4 == "1" ? 1 / 27242 : 1,
      Q4 == "1" ? 1 / 11699 : 1,
      Q4 == "1" ? 1 / 11553 : 1,
      Q4 == "1" ? 1 / 11250 : 1,
    ]

  return {
    Prior, OperationComplexity, CharacteristicTotal, EffectivenessTotal, CharacteristicEffectiveness, Safety, Cost
  }
}

const calSum = (a: number[]) => {
  return a && a.reduce((i, j) => i + j, 0)
}

const avg = (...a: number[]) => {
  let sum = calSum(a)
  return sum / a.length
}

const normalize = (a: number[]) => {
  let sum = calSum(a)
  return a && a.map(item => item / sum)
}

const params = {
  ALPHA_E: 0.1,
  ALPHA_S: 0.75,
  ALPHA_M: 0.55,
  ALPHA_O: 1
}
const normalizeWithParams = (a: number[], param: "ALPHA_E" | "ALPHA_S" | "ALPHA_M" | "ALPHA_O") => {
  return normalize(normalize(a)
    .map(v => 1 / Math.pow(v, params[param])))
}

function multiplyArrays(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    throw new Error("The arrays must have the same length.");
  }

  const result = arr1.map((num1, index) => num1 * arr2[index]);

  return result;
}

// 對應 Excel Sheet2 Output Table
const getOutput = (formVals: FormVals) => {
  console.log(formVals);

  const { Prior, OperationComplexity, EffectivenessTotal, CharacteristicTotal, Safety, Cost } = getCalculation(formVals)

  // const Prior_result = normalize(multiplyArrays(Prior, CharacteristicTotal))
  const Prior_result = normalize(Prior)
  const Operability_result = normalize(OperationComplexity)
  const Effectiveness_result = normalize(EffectivenessTotal)
  const Safety_result = normalize(Safety)
  const Economy_result = normalize(Cost)

  // const Weight = Prior_result.map((pr, idx) => {
  //   return pr * (Operability_result[idx] ** params.ALPHA_O) * (Effectiveness_result[idx] ** params.ALPHA_E) * (Safety_result[idx] ** params.ALPHA_S) * (Economy_result[idx] ** params.ALPHA_M)
  // })
  let arr = [1, 3, 5, 4, 2, 6]
  const Weight = Prior_result.map((pr, idx) => {
    return pr * (Operability_result[arr[idx] - 1] ** params.ALPHA_O) * (Effectiveness_result[idx] ** params.ALPHA_E) * (Safety_result[arr[idx] - 1] ** params.ALPHA_S) * (Economy_result[arr[idx] - 1] ** params.ALPHA_M)
  })

  const Recommend_Result = normalize(Weight)

  return {
    Prior_result,
    Effectiveness_result,
    Safety_result,
    Economy_result,
    Operability_result,
    Recommend_Result
  }
}

export { getOutput }
